import { render, staticRenderFns } from "./Taints.vue?vue&type=template&id=43a0502e&scoped=true&"
import script from "./Taints.vue?vue&type=script&lang=js&"
export * from "./Taints.vue?vue&type=script&lang=js&"
import style0 from "./Taints.vue?vue&type=style&index=0&id=43a0502e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a0502e",
  null
  
)

export default component.exports